module.exports = __webpack_public_path__ + "img/wrong-answer-illustration.7fd31071.png";